module.exports = __webpack_public_path__ + "img/shop1-5.74a824be.png";